module.exports = __webpack_public_path__ + "img/risk-lower.7da82266.png";